import './styles.css';
import GlobalNetworking from '../../../assets/Icons/Networking/globe-01.svg';
import Files from '../../../assets/Icons/Networking/folder-check.svg';
import People from '../../../assets/Icons/Networking/users-02.svg';
import Work from '../../../assets/Icons/Networking/briefcase-02.svg';

export function Graduates() {
  return (
    <section id="universities" className="section sectionAlt">
      <div className="container">
        <div className="sectionHead center">
          <h2>
            Built for the next generation of <span className="accent">European graduates</span>
          </h2>
        </div>

        <div className="cardGrid2">
          <div className="featureCard">
            <div className="iconCircle sm" aria-hidden="true">
              <img src={GlobalNetworking} alt="" className="graduateIcon" />
            </div>
            <h3>Global Networking</h3>
            <p className="muted">Build a professional network across European universities while you study.</p>
          </div>
          <div className="featureCard">
            <div className="iconCircle sm" aria-hidden="true">
              <img src={Files} alt="" className="graduateIcon" />
            </div>
            <h3>Cross-Disciplinary Teams</h3>
            <p className="muted">Work with designers, engineers, business and science students on the same project.</p>
          </div>
          <div className="featureCard">
            <div className="iconCircle sm" aria-hidden="true">
              <img src={People} alt="" className="graduateIcon" />
            </div>
            <h3>Real Project Experience</h3>
            <p className="muted">Move from coursework to shipped outcomes that you can show and defend.</p>
          </div>
          <div className="featureCard">
            <div className="iconCircle sm" aria-hidden="true">
              <img src={Work} alt="" className="graduateIcon" />
            </div>
            <h3>Career Readiness</h3>
            <p className="muted">Document collaboration history and skills — ready for internships and first roles.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

